import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
    apiKey: 'AIzaSyAv-AvlClviGJNXNjmRl-7FGoUdQlZKQGE',
    appId: '1:193595426995:web:321d56a6ffdc05a1ee48c6',
    authDomain: 'vesis-ui.firebaseapp.com',
    measurementId: 'G-4SHJC3GJBC',
    messagingSenderId: '193595426995',
    projectId: 'vesis-ui',
    storageBucket: 'vesis-ui.firebasestorage.app',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const dbRef = getDatabase(app);
